<template>
    <div class="cooper-user">
        <div class="btns">
            <a-button type="default">添加子账号</a-button>
            <a-button type="default">开启</a-button>
            <a-button type="default">冻结</a-button>
        </div>

        <a-table :columns="columns" :data-source="listData" :scroll="{ y: 520 }" :pagination="pagination">
            <template #action>
                <a style="display: block">开启</a>
                <a style="display: block">冻结</a>
            </template>
        </a-table>
    </div>
</template>

<script>
export default {
    data() {
        const listData = [];
        for (let index = 0; index < 100; index++) {
            listData.push({
                key: index + 1,
                name: '测试',
                age: index + 1,
                address: '123'
            });
        }
        return {
            listData,
            columns: [
                { title: '姓名', dataIndex: 'name', key: 'name' },
                { title: '手机号', dataIndex: 'age', key: 'age' },
                { title: '状态', dataIndex: 'address', key: '1' },
                {
                    title: '操作',
                    key: 'operation',
                    fixed: 'right',
                    width: 100,
                    scopedSlots: { customRender: 'action' }
                }
            ], 
            pagination: {
                total: listData.length,
                showQuickJumper: true,
                showSizeChanger: true,
                showTotal(total) {
                    return `总共${total}条`;
                },

                defaultCurrent: 1
            }
        }
    },
    methods:{

    }
}
</script>

<style lang="scss" scoped>
.cooper-user{
    .btns {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 8px;

        .ant-btn-default {
            background: #ffffff;
            font-size: 14px;
            color: #000000;
            border: 1px solid rgba(217, 217, 217, 1);
            margin-left: 8px;
            font-weight: normal;
            opacity: 0.85;
        }
    }

    .ant-table-wrapper{
        width: 960px;
    }
}
</style>